import { PublicationChannelRecord } from '@common/data-models/records/publication-channel-record';

export class PublicationChannelsResults {
    public byGuid: { [id: string]: PublicationChannelRecord } = {};

    public channels: Array<PublicationChannelRecord> = [];

    public add(rec: PublicationChannelRecord) {
        this.channels.push(rec);
        this.byGuid[rec.guid] = rec;
    }

    public remove(rec: PublicationChannelRecord) {
        if (this.byGuid[rec.guid]) {
            delete this.byGuid[rec.guid];
        }
        for (let i = 0; i < this.channels.length; i++) {
            if (this.channels[i].guid === rec.guid) {
                this.channels.splice(i, 1);
                break;
            }
        }
    }

    public dispose() {
        this.channels = [];
    }
}
